import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import "./../style.css";
import "./Performancestyle.css"
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import trueimages from "./../Asset/true-images.png";
import failimages from "./../Asset/fail-images.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Select from 'react-select';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Card, Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import RunReportNow from "../RunReportNow";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import Loader from "../CommonLoader";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import { datezonechange } from "./../Commonfun";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import rankedkeywordsicon from "../Asset/ESO/rankedkeywords.png";
import RankedKeywordssvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import WarningCount from ".././Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from ".././Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Chart from "react-apexcharts";
import ScoreGauge from "../../../Components/chart/gaugeChart";


export default function ContentStructureSummary() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const esodata = useSelector((state) => state);
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([])
  const [Domainsectiondata, SetDomainsectiondata] = useState([])
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [initialDateval, SetInitialDateval] = useState([]);
  const [fataloutCount, setfataloutCount] = useState();
  const [performancePlan, setperformancePlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    overall_score: 0,
    total_form_elements: 0,
    total_clickable_elements: 0,
    total_overflow_elements: 0,
    distribution: {
      "healthy": 0,
      "warning": 0,
      "critical": 0
    },
    top_5_worst: [],
    bottom_5_best: [],
    weekly_analysis: []
  });

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });


  let detailurl = `${process.env.REACT_APP_DOMAIN}content-structure-summary-detail/`;


  const checkUserPlan = async () => {
    const performanceP = await Utils("performance", ApiToken);
    if (performanceP.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      faqdatafun();
    }
    setperformancePlan(performanceP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  const columns = [


    {
      field: "link__url",
      headerName: "Page URL",
      description: 'URL of the domain.',
      minWidth: 350,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        let baseUrl = cardData.row.link__url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.link__url.split("/").slice(3).join("/");

        return (
          <>

            <Tooltip title={cardData.row.link__url}>
              <div className="prefered_url_external02">
                <a
                  target="_blank"
                  href={cardData?.row?.link__url}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },
    {
      field: "total_form_controls",
      headerName: "Form Element",
      description: 'Count of interactive input elements',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "overflowing_elements",
      headerName: "Overflow Element",
      description: 'Number of elements whose content extends beyond their visible boundaries',
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "clickable_elements",
      headerName: "Clickable Element",
      description: 'Count of clickable elements',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "View",
      headerName: "View",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          (cardData.row.overflowing_elements) ?
            <>
              <a href={detailurl + `${cardData.row.link__id}`}>
                <button className="view-report-button">
                  View Report
                </button>
              </a>
            </> : <></>
        );
      },
    },
  ]

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "", domainsecdata = "", pageNumber = 1, rowsPerPage = 10) => {
    // if (domainsecdata == "")
    //   domainsecdata = Domainsectiondata;
    if (jobid == "")
      jobid = jobidData;
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/content_structure_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        const dataval = datavalue?.data?.result;
        var newData = "";
        if (dataval && dataval.length > 0) {
          SetAutoheightval(false)
          const newData = dataval.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          setCardData(newData);
          if (jobidData == "") {
            const completevalues = await axios.get(
              `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=performance&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}`,
              {
                headers: {
                  Authorization: `${ApiToken}`,
                },
              }
            ).catch((error) => {
              if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error)
              }
              else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
              }
            });
            if (completevalues?.data) {
              const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
              SetInitialDateval(uniqueByCompletedAt[0]);
              setSelectval(uniqueByCompletedAt[0]?.value);
              SetdEngineoption(uniqueByCompletedAt[0]);
              setprevdEngineoption(uniqueByCompletedAt[0]);
              setcompletedate(uniqueByCompletedAt);
            }

          }
          setSummaryData({
            overall_score: datavalue?.data?.summary?.overall_score || 0,
            total_form_elements: datavalue?.data?.summary?.kpi_cards?.total_form_elements || 0,
            total_clickable_elements: datavalue?.data?.summary?.kpi_cards?.total_clickable_elements || 0,
            total_overflow_elements: datavalue?.data?.summary?.kpi_cards?.total_overflow_elements || 0,
            distribution: {
              "healthy": datavalue?.data?.summary?.distribution?.healthy || 0,
              "warning": datavalue?.data?.summary?.distribution?.warning || 0,
              "critical": datavalue?.data?.summary?.distribution?.critical || 0
            },
            top_5_worst: datavalue?.data?.summary?.top_5_worst || [],
            bottom_5_best: datavalue?.data?.summary?.bottom_5_best || [],
            weekly_analysis: datavalue?.data?.summary?.weekly_analysis || []
          })
          if (datavalue?.data?.job_date)
            setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
          else
            setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
        }
        else {
          setCardData("");
          SetAutoheightval(true)

        }

      }
    }
    catch (err) {
      console.log('err', err)
    }
    setTableLoading(false);
    setLoading(false);

  };

  const reportNow = async () => {
    setLoading(true);
    var errs = 1;
    let errors = {};
    if (selectval == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
      setLoading(false);
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    setjobidData(selectval?.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    callUserdataApi(selectval?.value, "");
  };
  function openModal() {
    if (performancePlan.status) {
      setIsOpen(true);
    }
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('performance')
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/content_structure_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&job_id=${jobidData}&timezone=${timezoneval()}&domain_section_id=${Domainsectiondata}&job_id=${jobidData}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("contentstructuresummary", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/content_structure_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&job_id=${jobidData}&timezone=${timezoneval()}&domain_section_id=${Domainsectiondata}&job_id=${jobidData}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("contentstructuresummary", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const LoadAddFormFilterOptions = async () => {
    SetSectionOptions([]);
    try {
      const doaminsectiondatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        if (doaminsectiondatavalue?.data?.domain_sections) {

          SetDoaminSectionUrl(doaminsectiondatavalue?.data?.domain_sections)
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) { }
  }
  const SetSectionNameHandle = (passvalue) => {
    if (passvalue) {
      SetDomainsectiondata(passvalue.value)
      callUserdataApi("", passvalue.value);
    } else {
      SetDomainsectiondata("")
      callUserdataApi();
    }
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=78`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };



  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const getPagination = (pageNumber = 1, rowsPerPage = 10) => {
    callUserdataApi("", Domainsectiondata, pageNumber, rowsPerPage);
  }


  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={summaryData.overall_score} width={'100px'} />
      </div>
    )
  }

  const cardDatas = [
    {
      value: summaryData.total_clickable_elements || 0,
      title: "Total Clickable Elements",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.total_form_elements || 0,
      title: "Total Form Elements",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    },
    {
      value: summaryData.total_overflow_elements || 0,
      title: "Total Overflow Elements",
      iconSrc: ErrorCount,
      iconColor: 3,
      bgColor: 3,
    },
    // {
    //   value: summaryData.overall_score || 0,
    //   title: "Overall Score",
    //   iconSrc: gaugeChart,
    //   iconColor: 3,
    //   bgColor: 3,
    // }
  ];

  const urls = Array.isArray(summaryData?.top_5_worst)
    ? summaryData.top_5_worst
    : [];
  const urls1 = Array.isArray(summaryData?.bottom_5_best)
    ? summaryData.bottom_5_best
    : [];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "40%"
      }
    },
    xaxis: {
      categories: urls?.map(item =>
        item.link__url.length > 20 ? item.link__url.slice(0, 20) + "..." : item.link__url
      ) || [],
      labels: {
        show: false   // 👈 hides numbers/text on x-axis
      },
      axisBorder: {
        show: false   // optional: remove axis line
      },
      axisTicks: {
        show: false   // optional: remove ticks
      }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => urls[opts.dataPointIndex]?.link__url
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries = [
    {
      name: "Total Form Controls",
      data: urls?.map(item => item.total_form_controls) || []
    },
    {
      name: "Overflowing Elements",
      data: urls?.map(item => item.overflowing_elements) || []
    },
    {
      name: "Clickable Elements",
      data: urls?.map(item => item.clickable_elements) || []
    }
  ];


  const chartOptions1 = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true, // better for long URLs
        barHeight: "60%"
      }
    },
    xaxis: {
      categories: urls1?.map(item =>
        item.link__url.length > 20 ? item.link__url.slice(0, 20) + "..." : item.link__url
      ) || [],
      labels: {
        show: false   // 👈 hides numbers/text on x-axis
      },
      axisBorder: {
        show: false   // optional: remove axis line
      },
      axisTicks: {
        show: false   // optional: remove ticks
      }
    },
    yaxis: {
      labels: {
        maxWidth: 150
      }
    },
    grid: {
      padding: {
        left: 20,
        right: 20
      }
    },
    tooltip: {
      x: {
        formatter: (val, opts) => urls1[opts.dataPointIndex]?.link__url
      },
      y: {
        formatter: (val) => val
      }
    }
  };

  const chartSeries1 = [
    {
      name: "Total Form Controls",
      data: urls1?.map(item => item.total_form_controls) || []
    },
    {
      name: "Overflowing Elements",
      data: urls1?.map(item => item.overflowing_elements) || []
    },
    {
      name: "Clickable Elements",
      data: urls1?.map(item => item.clickable_elements) || []
    }
  ];

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>

      {loading === true ? <Loader /> : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Content Structure Summary </title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <div style={{ color: "#000000", margin: "auto" }}>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Content Structure Summary
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Technical' },
                        { title: 'Performance Analysis' },
                        { title: 'Content Structure Summary', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-time">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>
                <div className="time_zone">
                  <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                  <span className="timezone-val">{timezoneval()}</span>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <Select
                    options={SectionOptions}
                    name="name"
                    onChange={SetSectionNameHandle}
                    placeholder="Domain Section"
                    isClearable
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    classNamePrefix="common-domain-dropdown_color"
                  />
                  <button
                    title="Run Report"
                    className="btn_dashboard"
                    onClick={() => {
                      if (first.statusDomain) {
                        setcheckD(first.statusDomain);
                      } else {
                        setfaqData(2)
                        setToggle(false)
                        SetRunReportPopShow(true);
                      }
                    }}
                    disabled={!performancePlan.status}
                  >
                    Run Report Now
                  </button>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="trendy-tabs-wrapper">
                  <div className="trendy-tab-container">
                    <button type="button" onClick={e => { navigate('/ux-analysis'); }}
                      className="trendy-tab" >UX Analysis</button>
                    <button type="button" onClick={e => { navigate('/network-health-summary'); }}
                      className="trendy-tab">Network Health</button>
                    <button type="button"
                      className="trendy-tab active" >Content Structure</button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-card-container">
          <Box >
            <Grid container spacing={2} className="dashboard-box-card">
              <Grid container spacing={3} xs={12} sm={12} md={6} justifyContent="center">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}

                <Grid item xs={12} sm={6} md={6}>
                  <Card
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                      transition: "0.3s",
                      cursor: "default",
                      height: "100%",
                      // border: 1px solid #e0e0e0;
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                      },
                      overflow: "hidden",
                      border: "none"
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#d1faf9',
                        p: 2.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 700,
                          fontSize: "2.5rem",
                          background: "linear-gradient(to right, #1f2937, #4b5563)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                          letterSpacing: 1,
                        }}
                      >
                        <div style={{ justifySelf: 'center' }}>{summaryData.overall_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                      </Typography>

                      <Box
                        sx={{
                          // backgroundColor: '#7c3aed',
                          color: "#059496",
                          // p: 1.5,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "1.5rem",
                        }}
                      >
                        {/* {icon} */}
                        {gaugeChart()}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        background: "#fff",
                        px: 2.5,
                        py: 3,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textTransform: "uppercase",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                      >
                        Overall Score
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Weekly Analysis</Typography>
                  <Chart
                    type="area"
                    height={220}
                    series={[
                      {
                        name: "Score",
                        data: summaryData.weekly_analysis.map(i => i.score)
                      }
                    ]}
                    options={{
                      chart: {
                        toolbar: { show: false }
                      },
                      colors: ["#ff601f"],
                      stroke: { curve: 'smooth', width: 3 },
                      fill: {
                        type: 'gradient',
                        gradient: {
                          shadeIntensity: 1,
                          opacityFrom: 0.4,
                          opacityTo: 0.1
                        }
                      },
                      xaxis: {
                        // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                        categories: summaryData.weekly_analysis.map(i =>
                          new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                        ),
                        tickPlacement: 'on', // 🔥 important
                        labels: {
                          offsetX: 50 // 👈 manual adjustment
                        }
                      },
                      yaxis: {
                        min: 0,
                        max: 80
                      },
                      grid: {
                        padding: { left: 0, right: 0 }
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-card-container">
          <Box>
            <Grid container spacing={3} className="dashboard-box-card">
              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top 5 Worst</Typography>
                  <Chart
                    options={chartOptions}
                    series={chartSeries}
                    type="bar"
                    height={350}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Bottom 5 Best</Typography>
                  <Chart
                    options={chartOptions1}
                    series={chartSeries1}
                    type="bar"
                    height={350}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Severity Distribution</Typography>
                  <Chart
                    type="donut"
                    height={240}
                    series={Object.values(summaryData.distribution)}
                    options={{
                      labels: Object.keys(summaryData.distribution),
                      colors: ['#2e7d32', '#4caf50', '#ffb74d', '#ffeb3b', '#fb8c00', '#e53935', '#b71c1c'],
                      legend: { position: 'bottom', fontSize: '10px' },
                      dataLabels: { enabled: false }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>


        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {performancePlan.status ?
                    <div>

                      <DatagridComp
                        columns={columns}
                        rows={rows}
                        autoheightval={autoheightval}
                        datagridval={2}
                        columnFreezeWidth={[0, 320]}
                        tableLoading={tableLoading}
                        handleModelPopUp={handleModelPopUp}
                        handleDownlodingCSV={handleDownlodingCSV}
                        handleDownlodingPDF={handleDownlodingPDF}
                        customFilter={true}
                        DownloadShowFile={true}
                        DownloadShowPDF={1}
                        DownloadShowCSV={2}
                      // paginationData={getPagination}
                      />
                    </div> : <Freeaudit planStatus={performancePlan} />
                  }
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
      </div>
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              <div>

                <div className="">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values)
                        SetdEngineoption(values);
                        setValidation({
                          dateerror: "",
                        })
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>


                </div>
                <span className="text-error">{validation.dateerror}</span>
              </div>

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={reportNow} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
          <button style={{ cursor: 'pointer' }} onClick={handleReset}>Reset</button>
          {/* <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button> */}
        </DialogActions>
      </Dialog>

      {!openCommonAlerts &&
        <>
          <CommonErrorAlert
            data={{
              apiopen: open,
              apiErrorMsg: 'No Data Found',
              isIconStyled: true
            }}
            closeAlert={handleClose} />
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        </>
      }
      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please verify your domain to access these features
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
      <UserActivityTracker pagename="Technical - Performance Analysis - Content Structure Summary" />
    </ div>
  );
}
